import * as React from "react";
import Notifications from '../components/Notifications';
import DataGrid from "../components/DataGrid";
import GetColumnDefs from "../components/ColumnDefs";
import { Button } from "@progress/kendo-react-buttons";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TextBox } from "@progress/kendo-react-inputs";
import configData from "../config.json";
import { GetSession, GetToken } from "../components/Session";
import { GetPermissions } from '../components/Options';
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { useNavigate } from "react-router-dom";
import { filterBy } from "@progress/kendo-data-query";

const Products = () => {
  const [lookupParams, setLookupParams] = React.useState("");
  const [sources, setSources] = React.useState([]);
  const [source, setSource] = React.useState();
  const [destinations, setDestinations] = React.useState([]);
  const [destination, setDestination] = React.useState();
  const [sites, setSites] = React.useState([]);
  const [site, setSite] = React.useState();
  const [directions, setDirections] = React.useState([]);
  const [direction, setDirection] = React.useState();
  const [stockLevel, setStockLevel] = React.useState(0);
  const [expanded, setExpanded] = React.useState(false);
  const statii = ["All", "Active", "Inactive"];
  const [status, setStatus] = React.useState("Active");
  const ready = React.useRef(false);
  const [columns, setColumns] = React.useState(null);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [permissions, setPermissions] = React.useState(null);
  const navigate = useNavigate();
  const [destdata, setdestData] = React.useState();
  const [srcdata, setsrcData] = React.useState();
  if (localStorage.getItem("userid") === null) navigate("/logout");
  if (permissions && !permissions.CanView) navigate("/error401");
  const options = React.useRef();
  let ps = localStorage.getItem("ProductSearch");
  const showSites = GetSession().SiteID === 1;


  const [layout, setLayout] = React.useState([
    { "field": "searchAdvanced", "label": "Advanced Search", "isVisible": true },
    { "field": "searchSite", "label": "Site", "isVisible": true },
    { "field": "searchSource", "label": "Source", "isVisible": true },
    { "field": "searchDestination", "label": "Destination", "isVisible": true },
    { "field": "searchDirection", "label": "Direction", "isVisible": true },
    { "field": "searchStatus", "label": "Status", "isVisible": true },
    { "field": "stockLevelBelow", "label": "Show Stock Level Below", "isVisible": true }
  ]);

  const subTotals = [
    { field: 'inLocalDiscount', aggregate: 'average' },
    { field: 'outLocalDiscount', aggregate: 'average' },
    { field: 'minLocalDiscount', aggregate: 'average' },
    { field: 'inVisitStandard', aggregate: 'average' },
    { field: 'outVisitStandard', aggregate: 'average' },
    { field: 'ePALevy', aggregate: 'average' },
    { field: 'minePALevy', aggregate: 'average' }
  ];

  const GetField = (f) => {
      return layout.find(obj => { return obj.field === f });
  }

  const sourceChanged = (event) => {
    setSource(event.target.value);
  };
  const destinationChanged = (event) => {
    setDestination(event.target.value);
  };
  const siteChanged = (event) => {
    setSite(event.target.value);
  };
  const directionChanged = (event) => {
    setDirection(event.target.value);
  };
  const stockLevelChanged = (event) => {
    setStockLevel(event.target.value);
  }
  const DoSearch = () => {
    if (ready.current) {
      var prodParam = {
        Source: source.id,
        Destination: destination.id,
        Site: site.id,
        Direction: direction,
        StockLevel: parseInt(stockLevel),
        Status: status
      };
      setLookupParams(encodeURI(JSON.stringify(prodParam)));
      localStorage.setItem("ProductSearch", JSON.stringify(prodParam));
    }
  };
  const ClearSearch = () => {
    if (ready.current) {
      ClearParams();
      var jobParam = {
        Source: "0",
        Destination: "0",
        Site: "0",
        Direction: "All",
        StockLevel: 0,
        Status: "Active"
      };
      setLookupParams(encodeURI(JSON.stringify(jobParam)));
      localStorage.removeItem("ProductSearch");
    }
  };
  const ClearParams = () => {
    setSource({ id: "0", name: "All" });
    setDestination({ id: "0", name: "All" });
    setSite({ id: "0", name: "All" });
    setDirection("All");
    setStockLevel(0);
    setStatus("Active");
  };

    const UpdateSavedParams = () => {
        if (ps === undefined) return;
        let def = JSON.parse(ps);
        setDirection(def.Direction);
        let src = options.current.sources.find(obj => { return obj.id === def.Source });
        if (src === undefined) src = { id: "0", name: "All" }
        setSource(src);
        let dst = options.current.destinations.find(obj => { return obj.id === def.Destination });
        if (dst === undefined) dst = { id: "0", name: "All" }
        setDestination(dst);
        let st = options.current.sites.find(obj => { return obj.id === def.Site });
        if (st === undefined) st = { id: "0", name: "All" }
        setSite(st);
        setStockLevel(def.StockLevel);
        setStatus(def.Status);
        var jobParam = {
            Source: def.Source,
            Destination: def.Destination,
            Site: def.Site,
            Direction: def.Direction,
            StockLevel: def.StockLevel,
            Status: def.Status
        };
        setLookupParams(encodeURI(JSON.stringify(jobParam)));
    }

  React.useEffect(() => {
    GetPermissions(["ViewProduct"], setPermissions);
    GetColumnDefs("products", setColumns, setErrorMessage);
    GetPermissions(["ViewProduct", "NewProduct", "EditProduct", "DeleteProduct", "ReportProduct"], setPermissions)
    let baseUrl = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'Products'";
    const init = {
      method: "GET",
      accept: "application/json",
      headers: {"Authorization": "Bearer " + GetToken()},
    };
    fetch(baseUrl, init).then(response => response.json()).then(d => { 
      if (GetSession().IsMobile){
          let data = [];
          for(let i = 0; i < d.length; i++){
              data.push({field: d[i].field, label: d[i].label, type:d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile});
          }
          setLayout(data);
      } else {
          setLayout(d); 
      }
    }); 
    baseUrl = configData.SERVER_URL + "apiv7/options";
    fetch(baseUrl, init)
      .then((response) => response.json())
        .then((d) => {
        options.current = d;
        let src = CreateList(d.sources);
        setSources(src);
        setsrcData(src);
        let dst = CreateList(d.destinations);
        setDestinations(dst);
        setdestData(dst);
        setSites(CreateList(d.sites));
        setDirections(d.directions);
        ready.current = true;
        if (ps !== undefined && ps !== "" && ps !== null) {
            setExpanded(true);
            setTimeout(() => { UpdateSavedParams() }, 100);
        } else {
            ClearParams();
        }
      });
  }, []);
  
  const CreateList = (d) => {
    var x = [{ id: "0", name: "All" }];
    return x.concat(d);
  };

  const RowStyle = (p) => {
      let bg = { backgroundColor: "white" };
      if (p.dataItem.stockLevel < p.dataItem.minimumStockLevel) {
          bg = { backgroundColor: "rgb(243, 23, 0, 0.5)" };
      } else {
          if (p.dataItem.stockLevel < p.dataItem.minimumStockLevel * 1.2) bg = { backgroundColor: "rgb(255, 255, 127, 1)" };
      }
      return bg;
  }
    const filterdesData = (filter) => {
        const desdata = destinations.slice();
        return filterBy(desdata, filter);
    };
    const filterdesChange = (event) => {
        setdestData(filterdesData(event.filter));
    };

    const filtersrctData = (filter) => {
        const srcdata = sources.slice();
        return filterBy(srcdata, filter);
    };
    const filtersrcChange = (event) => {
        setsrcData(filtersrctData(event.filter));
    };


  return (
    <div>
        <Notifications errorMessage={errorMessage}/>
        {GetField("searchAdvanced")["isVisible"] && <ExpansionPanel
        title={GetField("searchAdvanced")["label"]}
        expandIcon="fa fa-plus"
        collapseIcon="fa fa-minus"
        expanded={expanded}
        onAction={(e) => setExpanded(!e.expanded)}
      >
      <Reveal className="revealz">
          {expanded && (
            <ExpansionPanelContent>
              <div className="row" style={{ padding: "5px 10px" }}>
                {showSites && GetField("searchSite")["isVisible"] && <div className="col-md-3">
                  <label className="control-label">{GetField("searchSite")["label"]}</label>
                  <DropDownList
                    id="Site"
                    data={sites}
                    value={site}
                    textField="name"
                    dataItemKey="id"
                    onChange={siteChanged}
                  />
                </div>}
                {GetField("searchSource")["isVisible"] && <div className="col-md-3">
                  <label className="control-label">{GetField("searchSource")["label"]}</label>
                  <DropDownList
                    id="Source"
                    data={srcdata}
                    value={source}
                    onFilterChange={filtersrcChange}
                    filterable={true}
                    textField="name"
                    dataItemKey="id"
                    onChange={sourceChanged}
                  />
                </div>}
                {GetField("searchDestination")["isVisible"] && <div className="col-md-3">
                  <label className="control-label">{GetField("searchDestination")["label"]}</label>
                  <DropDownList
                    id="Destination"
                    data={destdata}
                    value={destination}
                    onFilterChange={filterdesChange}
                    filterable={true}
                    textField="name"
                    dataItemKey="id"
                    onChange={destinationChanged}
                  />
                </div>}
                {GetField("searchDirection")["isVisible"] && <div className="col-md-3">
                  <label className="control-label">{GetField("searchDirection")["label"]}</label>
                  <DropDownList
                    id="Direction"
                    data={directions}
                    value={direction}
                    onChange={directionChanged}
                  />
                </div>}
              </div>
              <div className="row" style={{ padding: "10px" }}>
                {GetField("stockLevelBelow")["isVisible"] && <div className="col-md-3">
                 <label className="control-label">{GetField("stockLevelBelow")["label"]}</label>
                 <TextBox id="StockLevelBelow" type="number" value={stockLevel} onChange={stockLevelChanged } />
                </div>}
                {GetField("searchStatus")["isVisible"] && <div className="col-md-3">
                    <label className="control-label">{GetField("searchStatus")["label"]}</label>
                    <DropDownList
                        id="Status"
                        data={statii}
                        value={status}
                        onChange={e => setStatus(e.value)}
                    />
                </div>}
              </div>
              <div className="row" style={{ padding: "10px" }}>
                <div className="col-md-5"></div>
                <div className="col-md-3">
                  <Button onClick={DoSearch} themeColor={"primary"}>
                    Search
                  </Button>{" "}
                  <Button onClick={ClearSearch} themeColor={"primary"}>
                    Clear
                  </Button>
                </div>
              </div>
            </ExpansionPanelContent>
          )}
        </Reveal>
      </ExpansionPanel>}
      {columns && permissions && <DataGrid
              dataSource="apiv7/products"
              params={lookupParams}
              dataFilter="productType eq 'W'"
              extraParam="/W"
              columns={columns}
              permissions={permissions}
              keyField="productId"
              rowStyle={RowStyle}
              subTotals={subTotals}
      />}
    </div>
  );
};

export default Products;
